import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
    TextField,
    Checkbox,
    FormControlLabel,
    Grid,
    Button, 
    Select,
    MenuItem,
    FormControl,
    InputLabel } from '@mui/material';
import { scholarshipLevel } from "../../../scholarship/enums";
import enumHelper from "../../../support/logic/enumHelper";
import { FinalFormCheckbox, FinalFormDropdown, FinalFormKeyboardDatePicker, FinalFormRadioGroup, FinalFormTextField } from "../../../common/formWrappers";
import AdvisorContext from "../../context/context";
import { toast } from "react-toastify";




const theme = createTheme({
    palette: {
        primary: {
            main: '#123225', // Your primary color
        },
        secondary: {
            main: '#2c6648', // Your secondary color
        },
    },
});



const renderTextField = ({ input, label, meta, multiline, rows, ...custom }) => (
    <TextField
        label={label}
        {...input}
        multiline={multiline}
        rows={rows}
        {...custom}
    />
);

const renderCheckbox = ({ input, label }) => (
    <FormControlLabel
        control={<Checkbox {...input} />}
        label={label}
        disabled
    />
);
const scholarshipLevelOptions = enumHelper.getSelectOptionsList(scholarshipLevel);
class StudentProfileForm extends Component {
    static contextType = AdvisorContext;

    constructor(props) {
        super(props);
        this.state = {
            selectedInstitutionId: props.student?.studentProfile?.selectedInstitutionId || "",
        };
    }

    handleInstitutionChange = (event) => {
        this.setState({ selectedInstitutionId: event.target.value });
    };


    componentDidMount = async () => {
        

    }
    componentDidUpdate(prevProps, prevState) {



    }


    onSubmit = (formValues) => {
        const updatedStudentProfile = {
            ...this.props.student.studentProfile,
            ...formValues
        };

        

        if (this.props.onUpdate) {
            this.props.onUpdate(updatedStudentProfile);
            toast.success("Student Updated.");
        }
    };


    render() {
        const { student } = this.props;
        const initialValues = {
            ...student?.studentProfile,
            passCode: student?.passCode 
        };
        return (
            <ThemeProvider theme={theme}>
            <Form
                onSubmit={this.onSubmit}
                initialValues={initialValues}
                render={({ handleSubmit, form, submitting, pristine }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Field name="userProfileId" component="input" type="hidden" />
                            <Field name="id" component="input" type="hidden" />
                            <Field name="nonOnwardStudent" component="input" type="hidden" />
                            <Field name="ssn" component="input" type="hidden" />
                            <Field name="alien" component="input" type="hidden" />
                            <Field name="sasId" component="input" type="hidden" />
                            <Field name="yearOfGraduation" component="input" type="hidden" />
                            <Field name="scholarshipLevel" component="input" type="hidden" />
                            <Field name="selectedInstitutionId" component="input" type="hidden" />
                            <Field name="otherInstitution" component="input" type="hidden" />
                            <Field name="collegeId" component="input" type="hidden" />
                            <Grid item xs={12} sm={4}>
                                <Field name="crusaderId" component={renderTextField} label="Onward ID" fullWidth disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field
                                    name="passCode"
                                    component={renderTextField}
                                    label="Pass Code"
                                    fullWidth
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>

                                <Field name="currentGrade" component={renderTextField} label="Grade" fullWidth />
                                
                            </Grid>
                            
                            
                            <Grid item xs={12} sm={4}>
                                <Field name="yearOfGraduation" component={renderTextField} label="Year of Graduation" type="number" fullWidth disabled={!this.context.myBasics.isAdmin} />
                            </Grid>
                            
                            <Grid item xs={12} sm={4}>
                                <Field name="studentId" component={renderTextField} label="Student ID" fullWidth />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Field
                                    name="iep"
                                    component={renderTextField}
                                    label="IEP"
                                    multiline
                                    rows={4} 
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field name="gap" component={renderCheckbox} label="GAP" type="checkbox" disable />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field name="honorific" component={renderCheckbox} label="Honorific" type="checkbox" disable />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field name="accelerate" component={renderCheckbox} label="Accelerate" type="checkbox" disable />
                            </Grid>
                            
                                
                           
                            <Grid item xs={12}>
                                <Button type="submit" disabled={submitting || pristine} variant="contained" color="primary">
                                    Submit
                                </Button>
                                <Button type="button" onClick={form.reset} disabled={submitting || pristine} variant="contained" color="secondary">
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                    </form>
                )}
                />
            </ThemeProvider>
        );
    }
}

export default StudentProfileForm;
